import React, { useEffect, useState } from 'react';
import { AlarmClock, ChevronRight } from 'lucide-react';
import { apiGet } from '../../lib/api';

// Compact banner of tenders with deadlines due today / tomorrow.
export default function DeadlineAlertsBanner({ onPick }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiGet('/enquiries/deadline-alerts').then(setData).catch(() => setData(null));
  }, []);

  if (!data || (data.count_today === 0 && data.count_tomorrow === 0)) return null;

  return (
    <div className="mb-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-2.5 flex items-center gap-3" data-testid="enq-deadline-banner">
      <AlarmClock size={16} className="text-amber-600 shrink-0" />
      <div className="text-xs text-amber-900 flex-1">
        <span className="font-display font-bold uppercase tracking-wide">
          {data.count_today} tender{data.count_today === 1 ? '' : 's'} due TODAY
        </span>
        <span className="mx-2 text-amber-400">·</span>
        <span className="font-display font-bold uppercase tracking-wide">
          {data.count_tomorrow} due TOMORROW
        </span>
      </div>
      <div className="hidden sm:flex flex-wrap gap-1.5 max-w-[55%] justify-end">
        {[...data.due_today, ...data.due_tomorrow].slice(0, 4).map((e, i) => (
          <button
            key={`${e.enquiry_id}-${e.deadline_type}-${i}`}
            onClick={() => onPick && onPick(e.enquiry_id)}
            className="inline-flex items-center gap-1 text-[10px] bg-white border border-amber-200 rounded px-1.5 py-0.5 hover:border-amber-400"
            data-testid={`enq-deadline-pill-${e.enquiry_id}`}
          >
            {e.title} · {e.deadline_type} <ChevronRight size={9} />
          </button>
        ))}
      </div>
    </div>
  );
}
